import DeadWaitState from "./dead-wait-state";
import WaitRespawnState from "./wait-respawn-state";
import GameState from "./game-state";
import { IGame } from "../types/game";

export default class DeadState extends GameState {
  couleur: number;
  thenGone: boolean;
  row: number;
  col: number;
  c: number;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(game: IGame, thenGone: boolean = false) {
    super(game);
    // Match original Player_dead constructor: do all initialization work here
    // Original: Player_dead::Player_dead(Canvas *c, bool tg) (line 1127)
    this.thenGone = thenGone;
    
    this.canvas.dying = true;
    for (this.row = 0; this.row < 36; this.row++) {
      for (this.col = 0; this.col < 18; this.col++) {
        if (this.canvas.blinded[this.row][this.col]) {
          this.canvas.bflash[this.row][this.col] = 24;
          this.canvas.dirted[this.row][this.col] = 2;
        }
        this.canvas.blinded[this.row][this.col] = 0;
      }
    }

    if (this.game.player.isLocal()) {
      if (this.game.notifyDeath) {
        this.game.notifyDeath(this.thenGone);
      } else {
        console.warn("[DeadState] notifyDeath hook not available!");
      }
    }

    // Determine death color: use fragger's color if there's a fragger, otherwise gray (color 8)
    // Note: We now use numPlayer, but getPlayer() takes connectionId, so color lookup is skipped for now
    // The color defaults to gray (9 << 4) if no fragger is found, which is acceptable
    let fraggerColor: number | undefined;
    // TODO: Add getPlayerByNumPlayer() method if fragger color is needed
    // For now, we skip color lookup since it's optional and defaults to gray

    if (fraggerColor !== undefined) {
      this.couleur = fraggerColor << 4; // Use fragger's color
    } else {
      this.couleur = 9 << 4; // Dark gray for natural death
    }

    //Suicide: less than 9 unit blocks in the 2 lines right
    let numUnits = 0;
    for (this.row = 14; this.row < 16; this.row++) {
      for (this.col = 4; this.col < 14; this.col++) {
        if (this.canvas.occupied[this.row][this.col]) numUnits++;
      }
    }

    if (numUnits < 9) {
    }
    if (this.thenGone) {
    }

    //Overkill and maximum overkill
    for (this.row = 0; this.row < 12; this.row++) {
      numUnits = 0;
      for (this.col = 4; this.col < 14; this.col++) {
        if (this.canvas.occupied[this.row][this.col]) numUnits++;
      }
      if (numUnits >= 8) break;
    }

    if (this.row < 10 && this.row >= 7) {
    }
    if (this.row < 7) {
    }

    this.row = 11;
    this.col = 4;

    this.c = 0;
    
    // Match original Player_dead constructor lines 1218-1220
    // Original: canvas->delete_bloc(); canvas->set_next();
    // CRITICAL: Clear current piece and prepare for next (matches original)
    this.canvas.bloc = null;
    this.canvas.next = null;
    this.canvas.next2 = null;
    this.canvas.next3 = null;
    this.canvas.blocShadow = null;
    // Note: set_next() in original only updates UI zones, doesn't generate pieces
    // Pieces will be generated when respawning via restart() or P_DOWNLOAD
  }

  enter(): void {
    // Match original Player_dead::init(): empty (no override in original)
    // All initialization is done in constructor
  }

  update(frameTime: number): void {
    super.update(frameTime);
    if (this.c++ & 1) return;
    if (this.col < 9) {
      if (this.canvas.occupied[this.row][this.col]) {
        this.canvas.blocks[this.row][this.col] =
          (this.canvas.blocks[this.row][this.col] & 15) + this.couleur;
        this.canvas.dirted[this.row][this.col] = 2;
      }
      if (this.canvas.occupied[42 - this.row][this.col]) {
        this.canvas.blocks[42 - this.row][this.col] =
          (this.canvas.blocks[42 - this.row][this.col] & 15) + this.couleur;
        this.canvas.dirted[42 - this.row][this.col] = 2;
      }
      if (this.canvas.occupied[this.row][17 - this.col]) {
        this.canvas.blocks[this.row][17 - this.col] =
          (this.canvas.blocks[this.row][17 - this.col] & 15) + this.couleur;
        this.canvas.dirted[this.row][17 - this.col] = 2;
      }
      if (this.canvas.occupied[42 - this.row][17 - this.col]) {
        this.canvas.blocks[42 - this.row][17 - this.col] =
          (this.canvas.blocks[42 - this.row][17 - this.col] & 15) +
          this.couleur;
        this.canvas.dirted[42 - this.row][17 - this.col] = 2;
      }
      this.row += 1;

      if (this.row >= 22) {
        this.col++;
        this.row = 11;
      }
    } else {
      this.canvas.dying = false;
      
      // Check if single player game should end
      // Reference: quadra/source/multi_player.cc:176-184
      // Original: if(game->single && game->terminated && game->net_list.all_gone())
      // Note: In single player, when death animation completes (col >= 9), the player is fully dead
      // We check here instead of waiting for idle >= 2 because idle is set to 2 in DeadWaitState
      if ((this.game as any).single && this.col >= 9) {
        // In single player, when player dies and animation completes, game is terminated
        (this.game as any).terminated = true;
        
        // Check if game should end (single player with terminated and player gone/dead)
        // In single player, "all_gone" means the player is dead (death animation complete)
        if ((this.game as any).onSinglePlayerGameEnd) {
          const score = (this.game as any).stats?.["SCORE"]?.getValue() || 0;
          const level = this.canvas.level || 1;
          const lines = (this.game as any).stats?.["LINESTOT"]?.getValue() || 0;
          (this.game as any).onSinglePlayerGameEnd(score, level, lines);
        } else {
          console.warn("[DeadState] onSinglePlayerGameEnd callback not set!");
        }
      }
      
      if (!this.thenGone) {
        // Match original Player_dead::step() lines 1260-1265
        // Original: if(then_gone) exec(new Player_gone(canvas, true));
        //           else if(canvas->islocal()) exec(new Player_dead_wait(canvas));
        //           else exec(new Player_wait_respawn(canvas));
        // exec() = call() + ret() (matches original overmind.cc:144-147)
        if (this.game.player.isLocal()) {
          this.exec(new DeadWaitState(this.game));
        } else {
          this.exec(new WaitRespawnState(this.game, false));
        }
      } else {
        // Match original: if(then_gone) exec(new Player_gone(canvas, true));
        // For now, we don't have GoneState, so just mark as done
        this.ret();
      }
    }
  }

  paint() {}

  toString(): string {
    return "Game Over";
  }
}
